import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FundHeaderComponentConfig } from '@products/fund-header/fund-header-component.config';
import { Subscription } from 'rxjs';
import { Component as BrComponent, Page } from '@bloomreach/spa-sdk';
import {
  Alert,
  FundSummaryCalcTypeVisibility,
  FundSummaryData,
  FundSummaryState,
  ProductDetailConfiguration,
} from '@types';
import { BaseProductDetailComponent } from '@products/base-product-detail.component';
import { FundSummaryService } from '../services/fund-summary.service';
import { SiteConfigService } from '@services';

@Component({
  selector: 'ft-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SummaryComponent
  extends BaseProductDetailComponent
  implements OnInit, OnDestroy {
  showIntlSummary: boolean;
  componentConfiguration: FundHeaderComponentConfig;
  dataSubscription: Subscription;
  fundSummaryInfo: FundSummaryData;
  calcTypeVisibility: FundSummaryCalcTypeVisibility;
  showRatings: boolean;
  isLitPreview = false;

  constructor(
    private fundSummaryService: FundSummaryService,
    private changeDetector: ChangeDetectorRef,
    private siteConfigService: SiteConfigService
  ) {
    super();
  }

  populate(
    componentConfig: FundHeaderComponentConfig,
    brConfig: ProductDetailConfiguration,
    component: BrComponent,
    page: Page
  ) {
    this.initialize(brConfig, component, page);
    this.componentConfiguration = componentConfig;
    if (this.brConfig.fundId) {
      this.dataSubscription = this.fundSummaryService.fundSummaryState.subscribe(
        (state: FundSummaryState) => this.mapState(state)
      );
      this.fundSummaryService.populate(brConfig);
    }
  }

  /**
   * Called when state changes.
   * @param state the new state returned by overview service with fund header response
   */
  mapState(state: FundSummaryState) {
    // NGC-13964: Canada ETF Product Pages to follow US version.
    // WDE-5195: Post introduction of hybrid funds, we now can't rely on fund level product type.
    //           Instead, we've to check product type at share class level.
    //           This will ensure correct display for fund summary template.
    this.showIntlSummary = this.siteConfigService.isCanada()
      ? state.shareClassProductType !== 'ETFs'
      : state.isSiteIntl;

    this.showRatings = state.showRatings;
    this.fundSummaryInfo = state.data;
    this.calcTypeVisibility = state.calcTypeVisibility;
    this.changeDetector.detectChanges();
  }

  ngOnInit() {
    this.isLitPreview =
      this.page?.getComponent()?.getParameters()?.pageType === 'lit-preview';
  }

  ngOnDestroy() {
    this.dataSubscription?.unsubscribe();
  }
}
